/** Implement a <Divider/> based component for all the search widgets */
import React from 'react';
import Divider from 'material-ui/Divider';

class SearchWidgetDivider extends React.Component {
  render() {
    return <Divider style={{marginTop: '8px'}} />;
  }
}

export default SearchWidgetDivider;
